import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import CrossIcon from "../CrossIcon";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  background-color: #fff;
  top: 50px;
  color: #252525;
  z-index: 5;
  .top {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .process {
    padding: 16px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: ${({ pathName }) =>
      pathName === "/ReferralDataList" ? "3px solid #1570ef" : "none"};
    color: ${({ pathName }) =>
      pathName === "/ReferralDataList" ? "#1570ef" : "none"};
    border-radius: 2px;
    &:hover {
      border-bottom: 3px solid #ccc;
      color: #1570ef;
    }
  }
  .history {
    padding: 16px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: ${({ pathName }) =>
      pathName === "/history" ? "3px solid #1570ef" : "none"};
    color: ${({ pathName }) => (pathName === "/history" ? "#1570ef" : "none")};
    border-radius: 2px;
    &:hover {
      border-bottom: 3px solid #ccc;
      color: #1570ef;
    }
  }

  .title {
    font-size: 20px;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .btn {
    display: flex;
    justify-content: space-between;
  }
`;

const CssAddButton = style(Button)({
  fontSize: 14,
  backgroundColor: "#057AFF",
  padding: "8px",
  boxShadow: "none",
  borderColor: "#057AFF",
  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
  ".MuiButton-startIcon": {
    marginRight: "4px",
  },
});

function HospitalManageTitle({ data }) {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [selfIdentities, setSelfIdentities] = useState([]);
  const OverLimit = data;
  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
  }, []);

  return (
    <Container pathName={location.pathname}>
      <div className="top">
        <div className="title">
          合作機構維護
          <i
            className="fa-solid fa-rotate"
            style={{ color: "#818181", cursor: "pointer" }}
            onClick={async () => {
              await queryClient.invalidateQueries("sendSearchData");
              await queryClient.invalidateQueries("getNoticeData");
            }}
          ></i>
        </div>
        <div className="btn">
          <div>
            <CssAddButton
              size="small"
              variant="contained"
              onClick={() => {
                navigate("/HospitalAdd");
              }}
              startIcon={<CrossIcon />}
            >
              新增合作醫院
            </CssAddButton>
          </div>
        </div>
      </div>
      <div className="bottom"></div>
    </Container>
  );
}

export default HospitalManageTitle;
